import { auth, db, Timestamp, } from "@/firebase/config"
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile, } from "firebase/auth"
import { doc, setDoc } from "firebase/firestore"
import { User, UserConverter } from "@/firebase/models/user_model"

/**
 * Class to add mock Auth Users
 */
const addMockAuthUsers = () => {
    const _defaultPass = 'Joseph35'
    
    /**
     * Adds the mock Auth users
     * @returns {Promise<void>}
     */
    const addUsers = async () => {
        for (const user of _createMockUsers()) {
            const userCred = await createUserWithEmailAndPassword(auth, user.email, _defaultPass)
            await setDoc(doc(db, 'Users', userCred.user.uid).withConverter(UserConverter), user)

            if (user.email === 'leach035@gmail.com') {
                console.log('Signing in user', user.email)
                const userCred = await signInWithEmailAndPassword(auth, user.email, _defaultPass)
                await updateProfile(userCred.user, { displayName: user.displayName, })
            }
        }
    }

    /**
     * @returns {Users[]}
     */
    function _createMockUsers() {
        return [
            new User(
                'Joseph Leach',
                Timestamp.now(),
                'leach035@gmail.com',
                'admin',
            ),
            new User(
                'User Test',
                Timestamp.now(),
                'user@test.com',
                'user',
            )
        ]
    }

    return { addUsers }
}

export default addMockAuthUsers
